export default "__VITE_ASSET__0D2m0l5h__"